import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type TripRecord = ResultOf<typeof tripRecordQuery>["trip"];

export const tripRecordQuery = graphql(`
  query TripRecord($id: ID!) {
    trip(id: $id) {
      id
      cityA {
        id
        name
      }
      cityB {
        id
        name
      }
      faqs {
        id
        question
        answer
      }
    }
  }
`);

export const updateTripFaqsMutation = graphql(`
  mutation UpdateTripFaqs($id: ID!, $faqs: [TripFaqInput!]!) {
    updateTripFaqs(id: $id, faqs: $faqs) {
      id
    }
  }
`);
